import * as React from 'react';

import { Box } from '~shared/components/Box';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconCopyPasteQuestionsSvg } from './IconCopyPasteQuestionsSvg';

export type IconCopyPasteQuestionsProps = UseIconProps;

export function IconCopyPasteQuestions(props: IconCopyPasteQuestionsProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <Box tagName={IconCopyPasteQuestionsSvg} {...iconProps} />;
}
